import { connect } from 'react-redux';
import { IReduxRootState } from '../app/reduxRootState.interface';
import SignOutLink, { ISignOutLinkOwnProps, ISignOutLinkStateProps } from './SignOutLink';

function mapStateToProps(state: IReduxRootState) {
    return {
        callbackUrl: state.app.appConfig.CALLBACK_URL,
        postLogoutUrl: state.app.clientConfig.postLogoutUrl,
    };
}

const SignOutLinkContainer = connect<
    ISignOutLinkStateProps,
    any,
    ISignOutLinkOwnProps,
    IReduxRootState
>(mapStateToProps)(SignOutLink);

export default SignOutLinkContainer;
